import React from "react";
import { ApolloProvider } from "react-apollo";
import { Router } from "@reach/router";
import { ThemeProvider } from "styled-components";
import { apiClient } from "../../graphql/client";
import theme from "../../utils/theme";
import GlobalStyles from "../../styled/globals/launchpad";
import SSO from "./routes/SSO";
import AddOns from "./routes/AddOns";
import Bundle from "./routes/Bundle";
import { AppGlobalStyles } from "./styled/app";

const App = () => (
  <ApolloProvider client={apiClient}>
    <ThemeProvider theme={theme}>
      <>
        <GlobalStyles />
        <AppGlobalStyles />
        <Router basepath="/fastrack">
          <SSO path="sso/:code" />
          <AddOns path="add_on/:addOnKey" />
          <Bundle path="bundle/:bundleKey" />
        </Router>
      </>
    </ThemeProvider>
  </ApolloProvider>
);

export default App;
